var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 44,
    fill: "url(#pattern0_27_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_27_16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_27_16",
    transform: "matrix(0.0111111 0 0 0.0108586 0 0.0113636)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_27_16",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEa0lEQVR4nO2cTYhcRRDHO7Lu69rNbqJBD3pUUEE8COYghFFR3JPGhKpZjOAXRINJwIs3nSCYzWaqZpmslyCK3lUQD178iKAmmoOe/UYSDUIIyeohuHGk30bw8N7s25edV91t/+APAzNQ1X/q9UdN84xJJBKJRCKRaB4UsMR9i3wGSAZFssRngeQjwN6z7vcKWYaPJV4sM7hQKN8DylbtvANjsOFytQ7WJv7Ttvlu7eyDop7RMrAop82u/rR2/sFgUY7UMfqy2S9p5x8Oj3cskIgl+a2G2T9qpx8Pnc5VlmS2zOxJ6t6unWJUWOSTJVu/F7RziwpAOVCyAzmmnVtUAHXvKpk+/tr08MJm7fxim6sLF0yLPdJOLyoA+Y2S6eNN7dyiAkh2liyIv7uK184vHnb1p4HkYkkPJPU/1hNA+bDE6APrGuj/DmD3+eIFkU9q5xYVWfvwTSUL4t8wO3+Ddn5RASTfFpmdkTypnVtUWOSFuh0/iERupwXIB02rMzYyozPq3a89UPBGfGhkRhvsjAPJBf1Biros8a+jnj7e1h4keKD8n6ZRkiE/pT1I8ECW+N2RGj35SPd6QLmkPVDQFvIe4zWPdSfHd/CtE8i78zsj2obVVIZyswmJjOTe/M6IB+ZF/5/p1PbFLYD8mQcGVpIlOWpCZRrlWiD+TtvEitppQiZrd+/xwMRVxMuuKEzoAPLHXk8bKCeu7MSHMu9OOw0kejo/vmJnvNBokme0zVxFL9evIuJDCgnPFeXitn4emFleKO3ettpGN1HJULVXgK9u1DZziC6Y3Uevrm90/jg3bvSp0Iy2JO+ZK8E9xo0njnywKJdxXLhF29DynGXverQ/55qobEt8Kje5ZDHMUJ5WN7RErghMLADxMW1DS/SziQWL0vLA0OInEeU1EwObHp27xucjeBT3DKddnwPlc20zS4VyyTW+TMhk2L0PiH9QN3P4tPGVCZUJ4gcB5VNtEyvqlXB7Gsh7PDCw6lha4fY02gu3aRtYTbxUViylpJ6G1Knm99dksnc9jYfmp/SrtYJQ9ofd09jhdzv0X7kpLuieBvjf4HfV/IsJHUD5RN3I1fW6Cf+QItomVngqZdaEfdzmn7RNrKCLwR67p7YvbrHIx4OoZpR3TIhkyA+Ec/WLlydnD99hgqDVGZug3p357iKg614r1cwvmmBodcYA+S1t02pMGUfcO6dMWAw2uJOVJT7nvcHEZzPkJ0zIbMT+dUC8z92Hzg8yxMvaxrrXYLi3NljiDwD5OdcS0PYpkUgkEolEIjRm+lm+r0Y5ASh/OOWfife576KLqwGg3GiRvxlyYPja/SaWuDrM9LNhg/3voNe1wrTiagEo+5u7g6wfVw1L/GXlngPy8dDjqgHES9V7ELwUelw1YC0DRj4felw1bJo6mgFWWqTNL4ZKcfWY6Wf5frXKNmutFwp9jKsJuIPDkEGP9MCiEFcXzO9n7125cuAWqlxf5I/tKCtKK24ikUgkEolEIpFIGM/4BzFEJkxDElGmAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastCart);
export default __webpack_public_path__ + "static/media/Fast Cart.54cf23e67ff3e34425d69e2252d3b77c.svg";
export { ForwardRef as ReactComponent };